import React from 'react';
import { useSettings } from '../contexts/SettingsContext';
import { useTranslation } from '../i18n/useTranslation';

const SETTINGS_SECTIONS = [
  { id: 'account',       icon: 'manage_accounts', labelKey: 'settings.sectionAccount' },
  { id: 'privacy',       icon: 'visibility',      labelKey: 'settings.sectionPrivacy2' },
  { id: 'notifications', icon: 'notifications',   labelKey: 'settings.sectionNotifications' },
  { id: 'appearance',    icon: 'palette',         labelKey: 'settings.sectionAppearance' },
  { id: 'language',      icon: 'language',        labelKey: 'settings.sectionLanguage' },
  { id: 'billing',       icon: 'credit_card',     labelKey: 'settings.sectionBilling' },
];

function SettingsNav({ isMobileOverlay = false }) {
  const { activeSection, setActiveSection } = useSettings();
  const { t } = useTranslation();

  return (
    <div className={`box-col group-align-std gnb2-modern${isMobileOverlay ? ' gnb2-mobile-overlay-inner' : ''}`} id="side-menu">
      <div className="box-col pd0 gnb2-nav-group">
        <span className="gnb-section-label">{t('user.settings')}</span>
        {SETTINGS_SECTIONS.map(({ id, icon, labelKey }) => (
          <button
            key={id}
            type="button"
            className={`side-menu-item${activeSection === id ? ' active settings-sidebar-item--active' : ''}`}
            onClick={() => setActiveSection(id)}
          >
            <span className="material-symbols-rounded">{icon}</span>
            <span className="gnb-menu-inv">{t(labelKey)}</span>
          </button>
        ))}
      </div>
    </div>
  );
}

export default SettingsNav;
